import { MATTRESS_SCHEMA_VERSION } from '@/domain/mattress/types';
/**
 * Ponto central de migrações de projetos entre versões do schema.
 *
 * v1 → v2: adiciona `perfilCliente` opcional (sem quebra — campo novo é undefined).
 */
export function migrateProject(raw) {
    if (!raw || typeof raw !== 'object') {
        throw new Error('Arquivo de projeto inválido');
    }
    let obj = raw;
    const version = obj.schemaVersion ?? 0;
    if (version > MATTRESS_SCHEMA_VERSION) {
        throw new Error(`Versão de schema (${version}) mais recente que a suportada (${MATTRESS_SCHEMA_VERSION})`);
    }
    // v1 → v2
    if ((obj.schemaVersion ?? 1) < 2) {
        obj = {
            ...obj,
            schemaVersion: 2,
            // perfilCliente fica undefined por padrão — backward compatible
        };
    }
    return obj;
}
